import React, { useState, useEffect } from "react"
import { ChevronRight, SmsOutlined } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { Badge, Modal } from "@mui/material"
import SignIn from "../Common/login"
import { getsessionuser } from "../Utils/sessions"
import Universalpageheader from "../Headers/universalpageheader"
import Searchbar from "../Components/searchbar"
import { useSelector } from "react-redux"
const { primarycolor } = require("../Utils/colors")

const Help = ({ onrefresh, onlogout }) => {

    const tuser = getsessionuser()
    const subProducts = useSelector((state) => state.subProducts.data);

    const navigate = useNavigate()
    const [user, setuser] = useState(tuser);
    const [cart, setcart] = useState(0);

    const [showlogin, setshowlogin] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);

    useEffect(() => {
        if (!user) {
            setshowlogin(true)
        }

        const houseobject = localStorage?.getItem("cart");//update number of items in cart
        if (houseobject) {
            const tcart = JSON.parse(houseobject)
            if (tcart.length > 0) {
                setcart(tcart.length)
            }
        }
    }, []);


    const onsuccesslogin = () => {
        setshowlogin(false)
        onrefresh()
        const userobject = localStorage?.getItem("user");
        if (userobject) {
            const object = JSON.parse(userobject)
            if (object) {
                setuser(object)
            }
        }
    }

    return (
        <div>
            {/* <Modal
                open={showlogin}
                onClose={() => {
                    setshowlogin(false)
                    navigate("/nav/hostels")
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Modal> */}
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader pagename={"Help"} onshowsearch={() => setshowsearchbar(true)} /><br />
            <div className="startlivechatbutton">
                <div className="livechaticon"><SmsOutlined fontSize="large" color="secondary" /></div>
                <div className="startchattext">Start Live Chat</div>
            </div><br />
            <div>
                <div style={{
                    width: "95%",
                    margin: "auto"
                }}>
                    <div className="menusectiontitle">ABOUT SIRGIL</div>
                    <div className="walletbuttons" onClick={() => navigate("/faqs")} >
                        <div className="walletbuttonsleft">
                            <div className="menubuttontext">&nbsp;Frequently Asked Questions</div>
                        </div>
                        <ChevronRight color={primarycolor} />
                    </div>
                    <div className="walletbuttons" >
                        <div className="walletbuttonsleft">
                            <div className="menubuttontext">&nbsp;Privacy Policy</div>
                        </div>
                        <ChevronRight />
                    </div>

                    <div className="menusectiontitle">APP INFO</div>
                    <div className="walletbuttons">
                        <div className="walletbuttonsleft">
                            <div className="menubuttontext">&nbsp;App Version 1.0.0</div>
                        </div>
                        <div>UP TO DATE</div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Help